import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import GetParticipantDataQuery from './GetParticipantDataQuery';
import UI from '../../../common/UI';
import useProject from '../../useProject';
import useQuery from '../../../api/useQuery';

interface LayoutProps {
  participantId: string;
  children: ReactNode;
}

const Layout = ({ participantId, children }: LayoutProps) => {
  const project = useProject();
  const { t } = useTranslation();

  const { data } = useQuery(
    GetParticipantDataQuery,
    {
      variables: {
        project_id: project.id,
        participant_id: participantId,
      },
    },
  );

  const participant = data?.project.participant;

  return (
    // Rerender when participant ID changes, to ensure scroll position
    // is reset when navigating from one participant to another.
    <UI.Div key={participantId}>
      <UI.Hero>
        <UI.Section>
          <UI.H1 sc={{ mb: 0, muted: !participant?.active }} style={{ minHeight: 30 }}>
            {participant?.full_name}
          </UI.H1>
        </UI.Section>

        <UI.Container sc={{ px: [0, 4] }}>
          <UI.Tabs sc={{ px: [2, 0] }}>
            <UI.Tab to={`/${project.id}/participants/${participantId}`} exact>
              {t('about')}
            </UI.Tab>
            <UI.Tab to={`/${project.id}/participants/${participantId}/orders`}>
              {t('orders')}
            </UI.Tab>
            <UI.Tab to={`/${project.id}/participants/${participantId}/communication`} exact>
              {t('communication')}
            </UI.Tab>
            <UI.Tab to={`/${project.id}/participants/${participantId}/notes`} exact>
              {t('notes')}
            </UI.Tab>
          </UI.Tabs>
        </UI.Container>
      </UI.Hero>

      <UI.Div>
        {children}
      </UI.Div>
    </UI.Div>
  );
};

export default Layout;
